"use client";

import { cn } from "@strivelabs/ui-core";
import { type ComponentProps, memo } from "react";
import { Streamdown } from "streamdown";

type ResponseProps = ComponentProps<typeof Streamdown>;

export const Response = memo(
  ({ className, components, ...props }: ResponseProps) => (
    <Streamdown
      className={cn(
        "size-full text-custom-text-primary [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
        className
      )}
      components={{
        // Customize link styling
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        a: ({ node, ...props }) => (
          <a
            {...props}
            className={cn(
              "text-custom-text-primary underline hover:text-custom-text-secondary",
              props.className
            )}
          />
        ),
        // Merge with any custom components passed in
        ...components,
      }}
      {...props}
    />
  ),
  (prevProps, nextProps) => prevProps.children === nextProps.children
);

Response.displayName = "Response";
